import { render } from "./CVPreviewModal.vue?vue&type=template&id=8a829bd2&scoped=true"
import script from "./CVPreviewModal.vue?vue&type=script&lang=js"
export * from "./CVPreviewModal.vue?vue&type=script&lang=js"

import "./CVPreviewModal.vue?vue&type=style&index=0&id=8a829bd2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a829bd2"]])

export default __exports__